export default __webpack_public_path__ + "static/media/about.153b1bb4.svg";